export type MenuVisibility = 'always' | 'multiBranch' | 'admin';

export interface NavigationMenuItem {
  id: string;
  name: string;
  icon: string;
  keywords?: string[];
  visibility?: MenuVisibility;
}

export interface NavigationMenuSection {
  title: string;
  items: NavigationMenuItem[];
  visibility?: MenuVisibility;
}

export const navigationMenuSections: NavigationMenuSection[] = [
  {
    title: 'ارائه',
    items: [
      {
        id: 'presentation',
        name: 'ارائه نگاه هوشمند',
        icon: 'presentation',
        keywords: ['ارائه', 'presentation', 'اسلاید'],
      },
    ],
  },
  {
    title: 'کلی',
    items: [
      {
        id: 'main',
        name: 'داشبورد عملکرد کلی',
        icon: 'chart-pie',
        keywords: ['عملکرد', 'کلی', 'KPI', 'فروش'],
      },
      {
        id: 'subscription',
        name: 'داشبورد اشتراک‌گیری',
        icon: 'chart-line',
        keywords: ['اشتراک', 'subscription'],
      },
      {
        id: 'sales',
        name: 'داشبورد فروش',
        icon: 'chart-line',
        keywords: ['فروش', 'sales', 'revenue'],
      },
    ],
  },
  {
    title: 'نبض بازار',
    items: [
      {
        id: 'market-pulse',
        name: 'نبض بازار',
        icon: 'trending-up',
        keywords: ['نبض', 'بازار', 'benchmark', 'market'],
      },
    ],
  },
  {
    title: 'برند',
    visibility: 'multiBranch',
    items: [
      {
        id: 'brand-overview',
        name: 'نمای کلی برند',
        icon: 'building',
        keywords: ['برند', 'brand', 'شعب'],
      },
    ],
  },
  {
    title: 'ارزیابی',
    items: [
      {
        id: 'evaluation-growth',
        name: 'داشبورد عملکرد کلی ارزیابی هوشمند',
        icon: 'trending-up',
        keywords: ['ارزیابی', 'evaluation', 'رشد'],
      },
      {
        id: 'satisfaction',
        name: 'داشبورد رضایت مشتریان',
        icon: 'smile',
        keywords: ['رضایت', 'نظرسنجی', 'CSAT', 'مشتری'],
      },
      {
        id: 'refine-customer',
        name: 'داشبورد دقیق سازی و پیگیری شکایت',
        icon: 'filter',
        keywords: ['شکایت', 'پیگیری', 'دقیق‌سازی', 'refine'],
      },
      {
        id: 'hr',
        name: 'تحلیل عملکرد پرسنل',
        icon: 'users',
        keywords: ['پرسنل', 'منابع انسانی', 'کارکنان', 'HR'],
      },
    ],
  },
  {
    title: 'باشگاه مشتریان',
    items: [
      {
        id: 'club',
        name: 'داشبورد جامع باشگاه مشتریان',
        icon: 'star',
        keywords: ['باشگاه', 'وفاداری', 'اعتبار', 'مشتریان'],
      },
      {
        id: 'customer-purchase-behavior',
        name: 'رفتار خرید مشتریان',
        icon: 'chart-bar',
        keywords: ['رفتار', 'خرید', 'تراکنش'],
      },
      {
        id: 'club-conditions',
        name: 'داشبورد شروط باشگاه مشتریان',
        icon: 'credit-card',
        keywords: ['شروط', 'اعتبار', 'conditions'],
      },
      {
        id: 'customer-analytics',
        name: 'تحلیل مشتریان',
        icon: 'chart-bar',
        keywords: ['تحلیل', 'مشتری', 'analytics'],
      },
      {
        id: 'customer-grouping',
        name: 'گروه‌بندی مشتریان',
        icon: 'users',
        keywords: ['گروه', 'segment', 'grouping'],
      },
    ],
  },
  {
    title: 'شخصی‌سازی',
    items: [
      {
        id: 'custom',
        name: 'داشبورد شخصی',
        icon: 'layout',
        keywords: ['شخصی', 'custom', 'سفارشی'],
      },
    ],
  },
  {
    title: 'مستندات',
    items: [
      {
        id: 'changelog',
        name: 'تاریخچه تغییرات',
        icon: 'history',
        keywords: ['تغییرات', 'changelog', 'نسخه'],
      },
      {
        id: 'product-doc',
        name: 'سند محصول',
        icon: 'file-text',
        keywords: ['سند', 'محصول', 'product', 'doc'],
        visibility: 'admin',
      },
    ],
  },
];
